import { render, staticRenderFns } from "./dollars-list.vue?vue&type=template&id=4e890666&scoped=true"
import script from "./dollars-list.vue?vue&type=script&lang=js"
export * from "./dollars-list.vue?vue&type=script&lang=js"
import style0 from "./dollars-list.vue?vue&type=style&index=0&id=4e890666&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e890666",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e890666')) {
      api.createRecord('4e890666', component.options)
    } else {
      api.reload('4e890666', component.options)
    }
    module.hot.accept("./dollars-list.vue?vue&type=template&id=4e890666&scoped=true", function () {
      api.rerender('4e890666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dollars/dollars-list.vue"
export default component.exports